<template>
  <div class="investor-drop-offs">
    <h5>Drop offs</h5>
    <p class="text-muted text-sm">
      Investors that explicitly expressed that they are not currently interested
      in the investment process.
    </p>

    <p v-if="investors.length === 0" class="text-muted text-sm">
      There are no drop-offs
    </p>

    <p v-if="investors.length > 0" class="text-muted text-sm">
      There are {{ investors.length }} drop-off<span v-if="investors.length > 1"
        >s</span
      >. Click <a href @click.prevent="toggleList()">here</a> to toggle them.
    </p>

    <ul v-show="visible">
      <li v-for="investor in investors" :key="investor.id">
        <a href @click.prevent="$refs.modal.open(investor)">
          {{ investor.name }}
        </a>
      </li>
    </ul>

    <InvestorListModal ref="modal" :show-apply-actions="false" />
  </div>
</template>

<script>
import InvestorListModal from 'modules/investor-list/InvestorListModal.vue'

export default {
  components: { InvestorListModal },
  props: {
    investors: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    toggleList() {
      this.visible = !this.visible
    },
  },
}
</script>
